import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import AttendanceMobileRow from './AttendanceMobileRow';
import AttendanceMobileAbsenceRow from './AttendanceMobileAbsenceRow';
import AttendanceMobileRowSkeleton from './AttendanceMobileRowSkeleton';

function Section({ title, children }) {
    return (
        <Box sx={{ mb: 2 }}>
            <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 700, letterSpacing: '0.05em' }}>
                {title}
            </Typography>
            <Divider sx={{ mb: 0.5 }} />
            {children}
        </Box>
    );
}

function AttendanceMobileList({ attendance, absences, onRowClick, onImageClick, loading, dateLabel }) {
    if (loading) {
        return (
            <Box>
                {Array.from({ length: 4 }).map((_, i) => (
                    <AttendanceMobileRowSkeleton key={i} />
                ))}
            </Box>
        );
    }

    const inProgress = attendance.filter(a => a.check_out === null);
    const completed = attendance.filter(a => a.check_out !== null);

    if (attendance.length === 0 && absences.length === 0) {
        return (
            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', py: 4 }}>
                Brak danych. Wyświetlany dzień to {dateLabel}
            </Typography>
        );
    }

    return (
        <Box>
            {inProgress.length > 0 && (
                <Section title={`W PRACY · ${inProgress.length}`}>
                    {inProgress.map(a => (
                        <AttendanceMobileRow key={a.id} attendance={a} onClick={onRowClick} onImageClick={onImageClick} />
                    ))}
                </Section>
            )}

            {completed.length > 0 && (
                <Section title={`ZAKOŃCZONE · ${completed.length}`}>
                    {completed.map(a => (
                        <AttendanceMobileRow key={a.id} attendance={a} onClick={onRowClick} onImageClick={onImageClick} />
                    ))}
                </Section>
            )}

            {absences.length > 0 && (
                <Section title={`URLOP · ${absences.length}`}>
                    {absences.map(abs => (
                        <AttendanceMobileAbsenceRow key={abs.id} absence={abs} />
                    ))}
                </Section>
            )}
        </Box>
    );
}

export default AttendanceMobileList;
